import React, { useCallback, useEffect, useState } from "react";
import moment from "moment";
import "moment/locale/pt";

import { Chip, Divider, Grid, Alert } from "@mui/material";
import { mapApiError } from "app/utils/errorMessages";
import DashboardCard from "../components/DashboardCard";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import { useAPI } from "app/hooks/useApi";
import { useNavigate } from "react-router-dom";
import DashboardLastMagazinesList from "../components/DashboardLastMagazinesList";
import Loading from "../components/Loading";

moment.locale("pt");

const Dashboard = () => {
  const [actualMagazine, setActualMagazine] = useState({
    number: "",
    date: "",
    linkDownloadPdf: "",
  });
  const [lastMagazines, setLastMagazines] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");

  const { authUser } = useJumboAuth();
  const { makeRequest, loading } = useAPI();
  const DATA_ATUAL = moment.utc().format("DD [de] MMMM [de] YYYY");
  const navigate = useNavigate();

  const getMagazines = useCallback(async () => {
  const response = await makeRequest("/dashboard/last-magazines", "GET");

    const statusCode = response.status;

    if (statusCode === 200) {
      const magazines = response.data;
      const firstMagazine = magazines?.[0];
      
      if (firstMagazine) {
        const { numeroRevista, dataRevista, linkPdf } = firstMagazine;
        const actualMagazineData = {
          number: numeroRevista || '- - -',
          date: dataRevista ? moment.utc(dataRevista).format("DD [de] MMMM [de] YYYY") : '- - -',
          linkDownloadPdf: linkPdf || '',
        };
        setActualMagazine(actualMagazineData);
        magazines.shift();
      }
      
      setLastMagazines(magazines || []);
    } else {
      setErrorMsg(mapApiError(response));
    }
  }, [setActualMagazine]);

  useEffect(() => {
    getMagazines();
  }, []);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <h1>Olá, {`${authUser ? authUser.name : "usuário"}`}!</h1>
        <Chip label={DATA_ATUAL} />
        <Divider sx={{ my: 2 }} />
      </Grid>
      <Grid item xs={6}>
        {loading ? (
          <Loading />
        ) : errorMsg ? (
          <Alert severity="error">{errorMsg}</Alert>
        ) : (
          <DashboardCard
            title={"Última RPI"}
            text={actualMagazine.number}
            date={actualMagazine.date}
            primaryButtonText={"Baixar"}
            secondaryButtonText={"Acessar"}
            actionPrimaryButton={() => {
              window.open(actualMagazine.linkDownloadPdf, "_blank");
            }}
            actionSecondaryButton={() => {
              window.open("https://revistas.inpi.gov.br/rpi/", "_blank");
            }}
          />
        )}
      </Grid>
      <Grid item xs={6}>
        {loading ? <Loading /> : <DashboardLastMagazinesList magazines={lastMagazines} />}
      </Grid>
    </Grid>
  );
};

export default Dashboard;
